import React, { useState, useEffect, useRef, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import ApiService from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import { IoAddSharp } from "react-icons/io5";
import { GrEdit } from "react-icons/gr";
import { FaRegEye } from "react-icons/fa6";

const SupplierMasterListing = () => {
    const [rowData, setRowData] = useState([]);
    const [loading, setLoading] = useState(true);
    let navigate = useNavigate();
    const [pageSize, setPageSize] = useState(20);
    const [pagination, setPagination] = useState();
    const [permissions, setPermissions] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const apiService = new ApiService();

    useEffect(() => {
        getItems();
        const storedPermissions = JSON.parse(localStorage.getItem('RoleAccess')) || [];
        const permissions = storedPermissions?.filter(acc => acc.formName === "Item Issue");
        setPermissions(permissions[0]);
    }, []);
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            let body = {
                take: 200,
                skip: 0,
                sortColumn: "id",
                sortDirection: 1,
                supplierId: "",
                name: "",
                type: "",
                phone: "",
                vatNo: "",
                accountName: ""
            }
            const res = await apiService.post('GET_SUPPLIER', body);

            setRowData(res?.data?.data?.items || []);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setLoading(false);
        }
    }
    const columnDefs = [
        { headerCheckboxSelection: true, checkboxSelection: true, headerCheckboxSelectionFilteredOnly: true, suppressMovable: true, width: 50 },
        { headerName: 'ID', field: 'id', width: 140, suppressMovable: true, },
        { headerName: 'Supplier ID', field: 'supplierId', width: 140, suppressMovable: true, },
        { headerName: 'Type', field: 'supplierType', width: 160, suppressMovable: true, },
        { headerName: 'Supplier Name', field: 'supplierName', width: 160, suppressMovable: true, },
        { headerName: 'Phone No', field: 'phoneNo1', width: 160, suppressMovable: true, },
        { headerName: 'VAT Reg No', field: 'vATRegNo', width: 160, suppressMovable: true, },
        { headerName: 'Contact Person', field: 'contactPerson1', width: 160, suppressMovable: true, },
        { headerName: 'Contact No', field: 'cP1ContactNo1', width: 160, suppressMovable: true, },
        { headerName: 'Credit Limit', field: 'creditLimit', width: 160, suppressMovable: true, },
        { headerName: 'Credit Days', field: 'creditDays', width: 160, suppressMovable: true, },
        { headerName: 'Account Code', field: 'accountCode', width: 160, suppressMovable: true, },
        { headerName: 'Account Name', field: 'accountName', width: 160, suppressMovable: true, },
    ]
    const handlenew = () => {
        navigate('/Inventory/Master/Supplier/Create')
    }
    const handleEdit = () => {
        navigate("/Inventory/Master/Supplier/Edit", { state: selectedRow });
    }
    const handleEye = () => {
        navigate(`/Inventory/Master/Supplier/${selectedRow?.id}`, { state: selectedRow });
    }
    const onSelectionChanged = async (event) => {
        const selectedRows = event.api.getSelectedRows();
        setSelectedRow(selectedRows.length === 1 ? selectedRows[0] : null);
    }
    return (
        <div className='p-4'>
            <div className='justify-content-between d-flex align-items-center'>
                <h4 className='mainInvHead'>
                    Supplier Master List
                </h4>
                <div className='d-flex justify-content-end gap-1'>
                    {permissions?.canAdd === true ?
                        <div className='col center'>
                            <button className='mainbtn ' type="submit" onClick={() => handlenew()}>
                                <IoAddSharp color='#fff' className='center mt-1' /> <div>Add</div>
                            </button>
                        </div>
                        : ''
                    }
                    <div
                        onClick={handleEdit}
                        className={`mainbtnSecondary flex-end gap-2}`}
                        style={{ cursor: 'pointer' }}
                    >
                        <GrEdit color='#fff' className='center mt-1 ' />
                        <div className='center'>Edit</div>
                    </div>
                    <div
                        onClick={handleEye}
                        className={`mainbtnGry flex-end gap-2 ${!selectedRow ? 'disabled' : ''}`}
                        style={{ cursor: selectedRow ? 'pointer' : 'not-allowed' }}
                    >
                        <FaRegEye color='#fff' className='center mt-1' />
                        <div className='center'>View</div>
                    </div>
                </div>
            </div>
            <div className='brderbox mt-3'>
                <div className="ag-theme-quartz" style={{ height: 530 }}>
                    <AgGridReact
                        getRowStyle={(params) => {
                            if (params.node.rowIndex % 2 === 0) {
                                return { background: '#F0EDF5' };
                            } else {
                                return { background: '#fff' };
                            }
                        }}
                        rowData={rowData}
                        rowSelection={'single'}
                        columnDefs={columnDefs}
                        onSelectionChanged={onSelectionChanged}
                        pagination={true}
                        paginationPageSize={20}   // rows per page
                        paginationPageSizeSelector={[10, 20, 50, 100]}
                    />
                </div>
            </div>
            {/* <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} /> */}
        </div>
    );
};

export default SupplierMasterListing;
